module.exports = __webpack_public_path__ + "img/11.27de5e4a.jpg";